export interface KPIS {
  study_uuid: string;
  kpis: KPI[];
}

export interface KPI {
  [x: string]: unknown;
  kpi_identifier: string;
  kpi_label: string;
  question_text: string;
  question_type: QuestionType;
  display_format: KPIDisplayFormat;
  question_options: KPIOption[] | null;
  global: boolean;
  kpi_formulas: KPIFormula[] | null;
  branched_from: string[];
}

export type LegacyCompatibleKPI = Omit<KPI, 'branched_from'> & {
  branched_from?: string[] | string | null;
};

export enum KPIType {
  PERCENTAGE = 'percentage',
  ABSOLUTE = 'absolute',
}

export interface KPIFormula {
  kpi_identifier: string;
  kpi_label: string;
  max_value: number;
  min_value: number;
  value_type: KPIType;
}

export enum QuestionType {
  TEXT = 'text',
  MULTIPLE = 'multiple',
  MULTIPLE_SOLE = 'multiple_sole',
  MULTIPLE_SOLE_RANGE = 'multiple_sole_range',
}

export interface KPIOption {
  option_identifier: string;
  option_label: string;
  option_order: number | null;
}

export enum KPILabel {
  AIDED_BRAND_AWARENESS = 'Aided Brand Awareness',
  CODECADEMY_STUDIES = 'Codecademy Studies',
  AMORELIE = 'Amorelie',
  BRAND_PERCEPTION = 'Brand Perception',
}

export enum KPIDisplayFormat {
  BAR = 'bar',
  LIST = 'list',
}

export interface KPIGroups {
  percentage: Array<string>;
  absolute: Array<string>;
}
